export default {
  experiences: 'Экскурсии',
  tours: 'Туры',
  audioguides: 'Аудиогиды',
  transfers: 'Трансферы',
} as const;
